import React from 'react';

export function ToolbarSection({ id, title, nepTitle, nep, children }) {
  const heading = nep ? nepTitle : title;
  return (
    <section className="a11y-section" aria-labelledby={id}>
      <h3 id={id} className="a11y-section__title">{heading}</h3>
      <div className="a11y-section__grid">
        {children}
      </div>
    </section>
  );
}

export default ToolbarSection;
